module.exports = __webpack_public_path__ + "static/media/Respiratory.7364c7f6.jpg";